import zhCn from 'element-plus/lib/locale/lang/zh-cn';
export default {
  data: function data() {
    return {
      locale: zhCn
    };
  }
};